<footer
  role="contentinfo"
  [attr.aria-label]="TRANSLATION_KEYS.footer.ARIA_LABEL | translate"
  [style.background-color]="(footerBackground || internalFooterBackground) === 'white' ? 'var(--colors-gray-scale-white)' : 'transparent'"
>
  <div [ngClass]="footerLayout === 'minimal' ? 'py-7.5 px-10' : 'pb-15 pt-7.5 px-10'" class="mx-auto gap-[11px] flex flex-col justify-center items-center">
    <!-- Sezione payoff e logo per homepage -->
    <section
      *ngIf="footerLayout === 'full'"
      class="flex flex-col items-center gap-3"
      aria-labelledby="footer-payoff"
      [attr.aria-label]="TRANSLATION_KEYS.footer.PAYOFF_SECTION_LABEL | translate"
    >
      <h2
        id="footer-payoff"
        class="font-normal text-xl leading-9 text-center m-0 text-black"
        aria-level="2"
      >
        {{ TRANSLATION_KEYS.footer.PAYOFF | translate }}
      </h2>
      <div
        class="flex justify-center items-center"
        [attr.aria-label]="TRANSLATION_KEYS.footer.LOGO_SECTION_LABEL | translate"
      >
        <ape-logo
          variant="footer"
          [logoSrc]="'assets/logo/logo-pixart.svg'"
          class="h-[50px] object-contain"
        />
      </div>
    </section>

    <!-- Informazioni copyright. Nel layout interno occupa la colonna del contenuto di pagina
         (stessi `max-w` e `px` di app.component.html) per spingere il badge a destra, e sotto i
         640px impila copyright e badge; in homepage resta il blocco centrato di prima -->
    <div
      class="flex items-center"
      [ngClass]="footerLayout === 'minimal' ? 'w-full max-w-[1348px] px-6 flex-col sm:flex-row justify-between' : 'justify-center'"
      [attr.aria-label]="TRANSLATION_KEYS.footer.COPYRIGHT_SECTION_LABEL | translate"
    >
      <!-- Impilati serve lo stacco dal badge; in riga lo spazio lo fa il justify-between -->
      <span
        class="font-light text-sm leading-sm text-center text-black"
        [ngClass]="footerLayout === 'minimal' ? 'mb-[10px] sm:mb-0' : ''"
      >
        {{ TRANSLATION_KEYS.footer.COPYRIGHT | translate: { currentYear } }}
      </span>

      <!-- Nel layout interno il badge sta in linea, a destra del copyright -->
      <ng-container
        *ngIf="footerLayout === 'minimal'"
        [ngTemplateOutlet]="poweredByBadge"
      />
    </div>

    <!-- In homepage il badge sta invece sotto al copyright, staccato -->
    <div
      *ngIf="footerLayout === 'full'"
      class="mt-4"
    >
      <ng-container [ngTemplateOutlet]="poweredByBadge" />
    </div>
  </div>
</footer>

<!--
  Badge "Powered by Alloy". E' identico nei due layout: cambia solo dove viene agganciato
  (in linea col copyright quando il footer e' minimal, sotto e con un margine quando e' full),
  quindi qui non ci sono classi di posizionamento: quelle stanno sui due punti di innesto.
-->
<ng-template #poweredByBadge>
  <div
    class="flex items-center justify-center gap-[6px] px-[14px] py-[7px] rounded-full border border-[#E5E9ED] bg-[linear-gradient(90deg,#F1F5F9_0%,#FFF_76.92%,#F1F5F9_100%)]"
  >
    <span class="text-[#87807D] text-[11px] font-normal leading-[11px]">
      {{ TRANSLATION_KEYS.footer.POWERED_BY | translate }}
    </span>
    <img
      src="assets/logo/logo-alloy.svg"
      [alt]="TRANSLATION_KEYS.footer.ALLOY_LOGO_ALT | translate"
    />
  </div>
</ng-template>